// Route generation — bumped by the router on every navigation. Screen
// loaders capture it before awaiting and compare before touching the DOM,
// so a slow response can never render into a route the user already left
// (codex HIGH-3).

export let routeGen = 0

export function bumpRouteGen(): void {
  routeGen++
}
